<div class="flex flex-col h-full">
  <div class="flex justify-between items-center mb-6">
    <div class="w-1/3">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search" />
        <input 
          type="text" 
          pInputText 
          [formControl]="searchControl"
          [placeholder]="'search' | translate" 
          class="w-full" />
      </p-iconField>
    </div>
    
    <app-button *hasPermission="'Laboratórios:create'"
      [label]="'laboratory_new' | translate"
      icon="pi pi-plus"
      (onClick)="onAdd()">
    </app-button>
  </div>

  <div class="flex-1 overflow-hidden">
    <app-prime-table
      [data]="laboratories"
      [columns]="columns"
      [loading]="loading"
      [totalRecords]="totalRecords"
      [rows]="rows"
      [lazy]="true"
      [paginator]="true"
      (onPage)="onPageChange($event)"
      [templates]="templates">
    </app-prime-table>
  </div>
</div>

<ng-template #actionsTpl let-item>
  <app-dropdown>
    <ng-template #trigger>
      <button pButton icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded p-button-secondary h-8 w-8"></button>
    </ng-template>
    <ng-template #content>
      <div class="flex flex-col min-w-[150px] py-1">
        <button class="flex items-center gap-2 px-4 py-2 hover:bg-slate-50 w-full text-left text-sm text-slate-700 transition-colors"
                (click)="onView(item)">
            <i class="pi pi-eye text-slate-400"></i>
            {{ 'view' | translate }}
        </button>
        <button *hasPermission="'Laboratórios:edit'" class="flex items-center gap-2 px-4 py-2 hover:bg-slate-50 w-full text-left text-sm text-slate-700 transition-colors"
                (click)="onEdit(item)">
            <i class="pi pi-pencil text-slate-400"></i>
            {{ 'edit' | translate }}
        </button>
        <button *hasPermission="'Laboratórios:delete'" class="flex items-center gap-2 px-4 py-2 hover:bg-slate-50 w-full text-left text-sm text-red-600 transition-colors"
                (click)="openDeleteModal(item)">
            <i class="pi pi-trash"></i>
            {{ 'delete' | translate }}
        </button>
      </div>
    </ng-template>
  </app-dropdown>
</ng-template>

<app-laboratory-modal
  [(visible)]="showLaboratoryModal"
  [laboratory]="selectedLaboratory"
  (saved)="onSaved()">
</app-laboratory-modal>

<!-- Delete Confirmation Modal -->
<p-dialog 
  [(visible)]="showDeleteModal" 
  [modal]="true" 
  [header]="'confirmation' | translate" 
  [style]="{ width: '450px' }">
    <div class="flex items-center gap-4 py-4">
        <i class="pi pi-exclamation-triangle text-amber-500 text-2xl"></i>
        <span>{{ 'laboratory_delete_confirm' | translate }}</span>
    </div>
    <div class="flex justify-end gap-2 mt-4">
        <app-button 
            [label]="'cancel' | translate" 
            variant="secondary" 
            (onClick)="showDeleteModal = false">
        </app-button>
        <app-button 
            [label]="'delete' | translate" 
            variant="danger" 
            (onClick)="confirmDelete()">
        </app-button>
    </div>
</p-dialog>
